module.exports = __webpack_public_path__ + "img/glamping-near-me.2.54571b7.jpg";